import Phaser from 'phaser';

export const NAMES = {
  COWBOY: 'cowboy',
  MEXICAN_WOMAN: 'mexican_woman',
  MONSTER: 'monster',
  NUN: 'nun',
  OLD_WOMAN: 'old_woman',
  SCREAM: 'scream',
};

const HEAD_POSITION = {
  [NAMES.COWBOY]: -270,
  [NAMES.MEXICAN_WOMAN]: -170,
  [NAMES.MONSTER]: -340,
  [NAMES.NUN]: -220,
  [NAMES.OLD_WOMAN]: -220,
  [NAMES.SCREAM]: -260,
};

const BODY_OFFSET_X = {
  [NAMES.NUN]: 25,
  [NAMES.OLD_WOMAN]: 15,
};

class Head extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y, name) {
    super(scene, x, y, `${name}_head`);

    this.setOrigin(0.5, 1);
    this.setScale(0.8);

    this.scene.add.existing(this);
  }

  fall() {
    this.scene.physics.add.existing(this);
    this.body.setCollideWorldBounds(true);
    this.body.setGravityY(300);
    this.body.setVelocity(-100, -20);
    this.body.setBounce(0.25);
    this.body.drag.x = 50;
    this.scene.tweens.add({
      targets: this,
      duration: 1500,
      angle: -130,
      ease: Phaser.Math.Easing.Quadratic.In,
    });
    this.scene.physics.add.collider(this, this.scene.ground);
  }
}

class Body extends Phaser.GameObjects.Sprite {
  constructor(scene, x, y, name) {
    super(scene, x, y, `${name}_body`);
    
    this.setOrigin(0.5, 1);
    this.setScale(0.8);

    this.scene.add.existing(this);
  }
}

class Face extends Phaser.GameObjects.DOMElement {
  constructor(scene, x, y, source) {
    const figure = document.createElement('figure');
    figure.classList.add('image', 'is-128x128');
    const image = document.createElement('img');
    image.src = source;
    figure.appendChild(image);

    super(scene, x, y, figure);

    this.setOrigin(0.5, 1);

    scene.add.existing(this);
  }
}

export default class Character extends Phaser.GameObjects.Container {
  constructor(scene, x, y, name) {
    super(scene, x, y);

    this.NAME = name;

    this._head = new Head(scene, 0, HEAD_POSITION[name], name);
    this._body = new Body(scene, BODY_OFFSET_X[name] || 0, 0, name);
    this.add([this._body, this._head]);
    
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.body.setOffset(-125, -320);
    this.body.setSize(250, 320);
    this.body.setCollideWorldBounds(true);
  }

  revealFace(source = 'https://randomuser.me/api/portraits/men/10.jpg') {
    this.remove(this._head);
    this._head = new Face(this.scene, 0, HEAD_POSITION[this.NAME], source);
    this.add(this._head);
    const fallingHead = new Head(this.scene, this.x, this.y + HEAD_POSITION[this.NAME], this.NAME);
    fallingHead.fall();
  }

  revealMonsterFace() {
    this.remove(this._head);
    this._head = new Head(this.scene, 0, HEAD_POSITION[this.NAME], 'vampire');
    this._head.setScale(1.1);
    this.add(this._head);
    const fallingHead = new Head(this.scene, this.x, this.y + HEAD_POSITION[this.NAME], this.NAME);
    fallingHead.fall();
  }
}

export function preload() {
  Object.values(NAMES).forEach(name => {
    this.load.image(`${name}_head`, `characters/${name}_head.png`);
    this.load.image(`${name}_body`, `characters/${name}_body.png`);
  });
  this.load.image('vampire_head', 'characters/vampire_head.png');
}
